import React from "react"
import boaterImage from "src/assets/auth/boater.png"
import marinaImage from "src/assets/auth/marina.png"

class AuthSignUpIntro extends React.Component {
  constructor(props) {
    super(props)
    this.goToMarina = this.goToMarina.bind(this)
    this.goToBoater = this.goToBoater.bind(this)
  }

  goToMarina() {
    document.location.href = "/claim"
  }

  goToBoater() {
    document.location.href = `/users/sign_up`
  }

  render() {
    return (
      <div className="auth-sign-up-intro">
        <h2 className="2xl text-center">
          Create Your
          <br />
          Dockwa Account
        </h2>
        <div className="row nested-row">
          <div className="col-xs-6">
            <div className="user-type-box bs-mb-3" onClick={this.goToMarina}>
              <img src={marinaImage} alt="marina logo" />
              <span>I&apos;m A Marina</span>
            </div>
            <button className="btn btn-primary" onClick={this.goToMarina}>
              Claim your marina
            </button>
          </div>
          <div className="col-xs-6">
            <div className="user-type-box bs-mb-3" onClick={this.goToBoater}>
              <img src={boaterImage} alt="black outlined compass logo" />
              <span>I&apos;m A Boater</span>
            </div>
            <button className="btn btn-primary" onClick={this.goToBoater}>
              Start Docking
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default AuthSignUpIntro
